import * as React from 'react';
import styled from 'styled-components';
import { SuccessIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import classNames from 'classnames';
import { DETAIL_MIN_ZOOM_LEVEL } from 'automation-ui-flow-core/canvas/graphConstants';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const borderColorMap = {
  success: 'fill-positive-pressed',
  danger: 'fill-alert-default'
};
const StyledBranchLabelBody = styled.div.withConfig({
  displayName: "BranchLabel__StyledBranchLabelBody",
  componentId: "bdypde-0"
})(["border:", " solid ", ";display:flex;padding:", ";width:250px;height:60px;align-items:center;justify-content:center;font-weight:", ";border-radius:", ";background-color:", ";&.showFooter{border-bottom-left-radius:0;border-bottom-right-radius:0;}&.customBorder{border-color:", ";border-width:", ";&.showFooter{border-bottom-width:", ";border-bottom-color:", ";}}&.smallScale{margin-top:-5px;font-size:", ";line-height:", ";height:30px;width:175px;zoom:160%;}"], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.typography['heading-200'].fontWeight, ({
  theme
}) => theme.borderRadius['200'], ({
  disabled,
  theme
}) => disabled ? theme.color['fill-surface-raised'] : theme.color['fill-surface-default'], ({
  theme,
  borderstyle
}) => theme.color[borderColorMap[borderstyle]], ({
  theme
}) => theme.borderWidth['300'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.typography['detail-100'].fontSize, ({
  theme
}) => theme.typography['detail-100'].lineHeight);
const StyledBranchLabelFooter = styled.div.withConfig({
  displayName: "BranchLabel__StyledBranchLabelFooter",
  componentId: "bdypde-1"
})(["display:flex;align-items:center;justify-content:center;width:250px;height:43px;padding:0 ", ";background-color:", ";border-radius:", ";border-top-left-radius:0;border-top-right-radius:0;border:", " solid ", ";border-top-width:0;&.customBorder{border-color:", ";border-width:", ";border-top-width:0;}"], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => theme.borderRadius['200'], ({
  theme
}) => theme.borderWidth['100'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme,
  borderstyle
}) => theme.color[borderColorMap[borderstyle]], ({
  theme
}) => theme.borderWidth['300']);
const BranchLabel = ({
  branchLabelFooterText,
  branchLabelHeaderText,
  branchDescription,
  footerTooltipTitle,
  borderStyle,
  hideFooter = true,
  zoomLevel = 1,
  disabled = false
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledBranchLabelBody, {
      className: classNames(!!borderStyle && "customBorder", !hideFooter && "showFooter", zoomLevel < DETAIL_MIN_ZOOM_LEVEL && "smallScale"),
      borderstyle: borderStyle,
      disabled: disabled,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(TruncateString, {
          matchContentWidth: true,
          children: branchLabelHeaderText
        }), zoomLevel >= DETAIL_MIN_ZOOM_LEVEL && /*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(TruncateString, {
            matchContentWidth: true,
            children: branchDescription
          })
        })]
      })
    }), !hideFooter && /*#__PURE__*/_jsx(UITooltip, {
      title: footerTooltipTitle,
      children: /*#__PURE__*/_jsxs(StyledBranchLabelFooter, {
        className: !!borderStyle ? "customBorder" : "",
        borderstyle: borderStyle,
        children: [/*#__PURE__*/_jsx(SuccessIcon, {
          size: "300"
        }), /*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineStart: "200",
          children: branchLabelFooterText
        })]
      })
    })]
  });
};
export default BranchLabel;